module.exports = __webpack_public_path__ + "img/img_grade12.fb86827a.jpg";